export class NotificationController {
    static addNotification(message, type) {
        const notificationGroup = document.querySelector('sotbit-notification-group');

        if (!notificationGroup) {
            console.warn('<sotbit-notification-group> element not found on page');
            return;
        }

        notificationGroup.addNotification(message, type);
    }
}
